import {CustomMarker} from "./CustomMarker";
import {myPropertyMarkerTemplateIcon} from "../templates/PropertyMarkerTemplate/MyPropertyMarkerTemplateIcon";

/**
 * Property marker class
 */
export class MyPropertyMarker extends CustomMarker {
    /**
     * @param latLng {LatLng}
     * @param attributes {PropertyAppResource}
     */
    constructor(latLng, attributes) {
        super(latLng, attributes);
    }

    /**
     * function that returns the template for the property marker icon
     * @returns {string}
     */
    templateIcon() {
        return myPropertyMarkerTemplateIcon(this);
    }

    templateCard(){
        return '';
    }

    getActiveIconClass() {
        return 'property-marker-icon-active';
    }
}
